import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, interval, Observable, of, tap } from 'rxjs';

import {
  ObjectCardExpandedState,
  ObjectCardKind,
  ObjectCardSettingsType,
  ObjectCardType,
} from '@common/components/object-card';
import { IObjectCardAdapter } from '@common/components/object-card-adapter';
import { AppService } from '@services/app.service';
import { ObjectsService } from '@services/objects.service';
import { selectCurrentUserObjectCardSettings } from '@store/selectors/current_user.selectors';

const REFRESH_INTERVAL_MS = 15000;

@Injectable()
export class ObjectCardAdapterService implements IObjectCardAdapter {
  private readonly store = inject(Store);
  private readonly objectsService = inject(ObjectsService);
  private readonly appService = inject(AppService);

  private openedObjectCard$ = new BehaviorSubject<ObjectCardType | null>(null);

  isClickableGeozones = false;

  loadObjectCardData(objectId: number, type: ObjectCardKind): void {
    this.objectsService.getObjectById(objectId, false, true, type).subscribe({
      next: (data) => this.openedObjectCard$.next(data),
      error: () => this.openedObjectCard$.next(null),
    });
  }

  startAutoRefresh$(objectId: number, type: ObjectCardKind): Observable<void> {
    return new Observable<void>((_) => {
      const sub = interval(REFRESH_INTERVAL_MS)
        .pipe(tap(() => this.loadObjectCardData(objectId, type)))
        .subscribe();

      return () => sub.unsubscribe();
    });
  }

  getOpenedObjectCard$(): Observable<ObjectCardType | null> {
    return this.openedObjectCard$.asObservable();
  }

  getMonitoringObject$(objectId: number): Observable<{ id: number } | undefined> {
    return of({ id: objectId });
  }

  getCurrentUserObjectCardSettings$(): Observable<ObjectCardSettingsType | null> {
    return this.store.select(selectCurrentUserObjectCardSettings);
  }

  closeObjectCard(): void {
    this.openedObjectCard$.next(null);
  }

  clearObjectCard(): void {
    this.openedObjectCard$.next(null);
  }

  goToGeozoneBounds(_geozoneId: number): void {
    // в CMS карты нет — метод существует только ради контракта адаптера
  }

  getExpandedItemsState(): ObjectCardExpandedState {
    return this.appService.stateObjectCardSettings;
  }
}
